const error = {
  title: 'The requested page could not be found.',
  subtitle: 'Check if the address or URL was misspelled or go back to:',
  button: {
    1: 'Home',
    2: 'Product search',
    3: 'Upload (e-)recipe',
    4: 'Login',
  },
}

export default error
